"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_i18n_1 = require("vue-i18n");
const ui_kit_1 = require("@extracadabra/ui-kit");
exports.default = (0, vue_1.defineComponent)({
    __name: 'NoDocument.component',
    setup(__props) {
        const { t } = (0, vue_i18n_1.useI18n)();
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                (0, vue_2.createVNode)((0, vue_2.unref)(ui_kit_1.Icon), {
                    name: "xmark-to-slot",
                    type: "fad",
                    size: "5",
                    color: "primary",
                    style: { "opacity": "0.2" }
                }),
                (0, vue_2.createElementVNode)("p", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("CORE.DOCUMENTS.@NO_DOCUMENTS")), 1)
            ]));
        };
    }
});
